import { isEmpty } from './helpers/isEmpty.js';
import { email } from './email.js';

/**
 * Expresión regular para el separador permitido entre emails
 */
const EMAIL_SEPARATOR = /[;,]+/;

/**
 * Devuelve true si
 * - no valor
 * - el formato de todos los emails es correcto y están separados por ';' o ','
 *
 * @param {string} value el valor
 * @returns {boolean} true === válido
 */
export function emailMultiple(value) {
  if (isEmpty(value)) {
    return true;
  }

  // No permitimos que termine con el separador
  if (typeof value !== 'string' || EMAIL_SEPARATOR.test(value.slice(-1))) {
    return false;
  }

  // Reutilizamos el validador base email: Todos los email deben pasarlo
  return value.split(EMAIL_SEPARATOR).every(email);
}
